<template>
	<div class="mb-4">
		<RenewsList></RenewsList>
	</div>
</template>

<script>
import RenewsList from "../Widgets/Renews/RenewsList.vue";
export default {
  name: 'Renews',
  components: {
    RenewsList
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>